/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const NotificationsQueryKeys = {
  all: ['user'] as const,
  lists: () => [...NotificationsQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...NotificationsQueryKeys.lists(), { filters }] as const,
  details: () => [...NotificationsQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...NotificationsQueryKeys.details(), id] as const,
};
